import React from "react";
import { joinClasses } from "../../utils/joinClasses";
export const DropdownDivider = ({ className, ...props }) => (React.createElement("div", { className: joinClasses(["nxm-dropdown-divider", className]), role: "separator", ...props }));
